import React, { useEffect, useState } from 'react';

export const ParticipantStudyDetails = ({ participant }) => {
  const [protocolId, setProtocolId] = useState('');
  const [studyName, setStudyName] = useState('');
  const [type, setType] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [accrualDate, setAccrualDate] = useState(null);
  const [description, setDescription] = useState('');
  const [province, setProvince] = useState('');
  const [district, setDistrict] = useState('');
  const [subDistrict, setSubDistrict] = useState('');
  const [facility, setFacility] = useState('');
  const [coEnrolmentAllowed, setCoEnrolmentAllowed] = useState('');
  const [enrolmentDate, setEnrolmentDate] = useState('');
  const [durationPerParticipant, setDurationPerParticipant] = useState('');
  const [enrolmentWindow, setEnrolmentWindow] = useState('');

  useEffect(() => {
    if (participant || participant.studyDetails) {
      setProtocolId(participant?.studyDetails?.protocolID || 'N/A');
      setStudyName(participant?.studyDetails?.studyName || 'N/A');
      setType(participant?.studyDetails?.type || 'N/A');
      setStartDate(participant?.studyDetails?.startDate || 'N/A');
      setEndDate(participant?.studyDetails?.endDate || 'N/A');
      setAccrualDate(participant?.studyDetails?.accrualDate || 'N/A');
      setDescription(participant?.studyDetails?.description || 'N/A');
      if (participant?.studyDetails?.coEnrolmentAllowed) {
        setCoEnrolmentAllowed('Yes');
      } else {
        setCoEnrolmentAllowed('No');
      }
      setProvince(participant?.studyDetails?.province || 'N/A');
      setDistrict(participant?.studyDetails?.district || 'N/A');
      setSubDistrict(participant?.studyDetails?.subDistrict || 'N/A');
      setFacility(participant?.studyDetails?.facility || 'N/A');
      setDurationPerParticipant(participant?.studyDetails?.studyDurationPerParticipant || 'N/A');
      setEnrolmentWindow(participant?.studyDetails?.newStudyOrTrialEnrollmentWindow || 'N/A');
      setEnrolmentDate(participant?.studyDetails?.firstEnrolmentDate || 'N/A');
    }
  }, [participant]);

  const renderLeftTopInformation = () => {
    return (
      <div className="form-section-left">
        <div className="input-container">
          <label className="input-label">Protocol ID: </label>
          <label>{protocolId}</label>
        </div>
        <div className="input-container">
          <label className="input-label">Study Name: </label>
          <label>{studyName}</label>
        </div>

        <div className="input-container">
          <label className="input-label">Type: </label>
          <label>{type}</label>
        </div>

        <div className="input-container">
          <label className="input-label">Start Date: </label>
          <label>{startDate}</label>
        </div>

        <div className="input-container">
          <label className="input-label">End Date: </label>
          <label>{endDate}</label>
        </div>

        <div className="input-container">
          <label className="input-label">Accrual Date: </label>
          <label>{accrualDate}</label>
        </div>
      </div>
    );
  };

  const renderRightTopInformation = () => {
    return (
      <div className="form-section-right">
        <div className="input-container">
          <label className="input-label-right">Province: </label>
          <label>{province}</label>
        </div>
        <div className="input-container">
          <label className="input-label-right">District: </label>
          <label>{district}</label>
        </div>

        <div className="input-container">
          <label className="input-label-right">Sub-District: </label>
          <label>{subDistrict}</label>
        </div>

        <div className="input-container">
          <label className="input-label-right">Facility: </label>
          <label>{facility}</label>
        </div>
      </div>
    );
  };

  const renderLeftBottomInformation = () => {
    return (
      <div className="form-section-left">
        <div className="input-container">
          <label className="input-label">Co-Enrolment Allowed: </label>
          <label>{coEnrolmentAllowed}</label>
        </div>
        <div className="input-container">
          <label className="input-label">First Enrolment Date: </label>
          <label>{enrolmentDate}</label>
        </div>
      </div>
    );
  };

  const renderRightBottomInformation = () => {
    return (
      <div className="form-section-right">
        <div className="input-container">
          <label className="input-label-long">Study Duration Per Participant: </label>
          <label>{durationPerParticipant}</label>
          <label className="input-label-xsm">days. </label>
        </div>
        <div className="input-container">
          <label className="input-label-long">New Study/Trial Enrolment Window: </label>
          <label>{enrolmentWindow}</label>
          <label className="input-label-xsm">days. </label>
        </div>
      </div>
    );
  };

  return (
    <div className="participant-study-details">
      <div className="participant-study-details-info">
        {renderLeftTopInformation()}
        {renderRightTopInformation()}
      </div>
      <div className="participant-study-details-info">
        <div className="input-container" style={{ width: '80%' }}>
          <label className="input-area-label">Description: </label>
          <textarea className={'input-area'} value={description} disabled />
        </div>
      </div>
      <div className="participant-study-details-info">
        {renderLeftBottomInformation()}
        {renderRightBottomInformation()}
      </div>
    </div>
  );
};
